import { render, staticRenderFns } from "./DonutChart30.vue?vue&type=template&id=20076c93&scoped=true"
import script from "./DonutChart30.vue?vue&type=script&lang=js"
export * from "./DonutChart30.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20076c93",
  null
  
)

export default component.exports